import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { useCart } from "../context/CartContext";

const BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * Public part card. Deliberately mirrors the TyreCard visual language so the
 * catalogue feels unified across products.
 */
const PartCard = ({ part }) => {
  const { addItem } = useCart();
  const inStock = part.stock > 0;
  const src = part.image
    ? (part.image.startsWith("http") ? part.image : `${BASE}${part.image}`)
    : "";

  const add = (e) => {
    e.preventDefault();
    if (!inStock) return;
    addItem({
      tyre_id: part.id,        // reuse cart schema — tyre_id acts as generic product id
      name: part.name,
      price: part.price,
      image: src,
      quantity: 1,
    });
  };

  return (
    <Link to={`/parts/${part.id}`} className="vd-card overflow-hidden flex flex-col group" data-testid={`part-card-${part.id}`}>
      <div className="aspect-[4/3] overflow-hidden" style={{ background: "var(--bg-secondary)" }}>
        {src && <img src={src} alt={part.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-400" />}
      </div>
      <div className="p-4 flex flex-col flex-1">
        <p className="vd-muted text-[11px] uppercase tracking-wider mb-1">{part.brand || "Aftermarket"} · {part.condition}</p>
        <h3 className="vd-heading text-[15px] font-semibold leading-snug mb-2 line-clamp-2" style={{ minHeight: 42 }}>{part.name}</h3>
        {part.fitment?.length > 0 && (
          <p className="vd-muted text-xs mb-2">
            Fits {part.fitment.slice(0, 2).map((f) => `${f.make} ${f.model}`).join(", ")}
            {part.fitment.length > 2 ? "…" : ""}
          </p>
        )}
        {part.part_number && <p className="vd-muted text-xs mb-3">P/N {part.part_number}</p>}
        <div className="mt-auto flex items-center justify-between">
          <span className="font-extrabold text-lg" style={{ color: "var(--primary-red)" }}>£{part.price.toFixed(2)}</span>
          <span className="text-xs font-semibold" style={{ color: inStock ? "#00A35C" : "var(--primary-red)" }}>
            {inStock ? `In stock · ${part.stock}` : "Out of stock"}
          </span>
        </div>
        <button
          onClick={add}
          disabled={!inStock}
          className="vd-btn-primary mt-3 w-full"
          data-testid={`part-add-basket-${part.id}`}
        >
          <ShoppingCart size={16} /> {inStock ? "Add to Basket" : "Unavailable"}
        </button>
      </div>
    </Link>
  );
};

export default PartCard;
